import React, { useEffect, useState, useContext, useRef } from 'react';
import { IonButton, IonSlides, IonGrid, IonTabs, IonTab, IonTabBar, IonTabButton, IonToolbar, IonTitle, IonContent, IonHeader, IonLabel, IonRouterOutlet, IonFooter, IonCard, IonList, IonItem, IonicSlides, IonText } from '@ionic/react';
import { IonSlide, IonRow, IonCol, IonImg } from '@ionic/react';
import '../css/zPublic.css';

import {Hotels_Homepage} from '../components/Homepage_hotel';
import {ProService_Homepage} from '../components/Homepage_proService';
import {Retail_Homepage} from '../components/Homepage_retail';

import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';

import { GPSC_Component } from './Merchant_GeoLocation';
import {CachedImage} from './Component_CachedImage'; // Import CachedImage component



export function Search_Home (props)
{

    let authMerchant_objects = useContext(Auth_MerchantID_context);

    let [acctID, setAcctID ] = useState(authMerchant_objects.acctID);
    let [baseURL, setBaseURL ] = useState(authMerchant_objects.baseURL);

    let [searchResults, setSearchResults] = useState([]);

    let [companyID, setCompanyID] = useState(null);
    let [companyName, setCompanyName] = useState(null);
    let [businessType, setBusinessType] = useState(null);
    let [companyAddressNumber, setCompanyAddressNumber] = useState(null);
    let [companyStreetName, setCompanyStreetName] = useState(null);
    let [companyCity, setCompanyCity] = useState(null);
    let [companyCityDistrict, setCompanyCityDistrict] = useState(null);
    let [companyPhoneNumber, setCompanyPhoneNumber] = useState(null);
    let [companyEmail, setCompanyEmail] = useState(null);
    let [customerRating, setCustomerRating] = useState('0.00000');
    let [companyLatitude, setCompanyLatitude] = useState(null);
    let [companyLongitude, setCompanyLongitude] = useState(null);

    let [hotelHompageModal, setHotelHomepageModal] = useState(false);
    let [proServicesHomepageModal, setProServiceHomepageModal] = useState(false);
    let [retailHompageModal, setRetailHomepageModal] = useState(false);


        

    useEffect(() => {

        //alert("In Use Effect");
        
        setSearchResults([]);

            const requestOptions = {
                method:'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                 },
                body: JSON.stringify({
                    Tracker: "74002S_search_home",
                    user: acctID,
                    xSupplierSearchName: props.data.searchData,
                })            
            }
    
                //alert("IN USEEFECT List HOTEL 2");
                //alert(baseURL);

            fetch(baseURL+'merchants_argsApp', requestOptions)
            .then(res => res.text())
            .then(res => {

                let rows = res.toString().split('~~~');
                for(let rowNum = 0; rowNum < rows.length - 1; ++rowNum)
                {

                    let cols = rows[rowNum].split('|');

                    setSearchResults((prevsearchResults) => {
                        return prevsearchResults.concat({
                            companyAcctID: cols[0],
                            companyName: cols[1],
                            businessType: cols[2],
                            companyAddressNumber: cols[3],
                            streetName: cols[4],
                            city: cols[5],
                            cityDistrict: cols[6],
                            companyPhoneNumber: cols[7],
                            companyEmail: cols[8],
                            companyImage: cols[9],
                            customerRating: cols[10],
                            latitude: cols[11],
                            longitude: cols[12],
                        })

                    });
                }

                props.confirmComplete();


            })
    }, [props.data.searchTerm]);

    function zPub_selectMerchantID(e)
    {
        //e.preventdefault();

        //props.merchantIDB(e);
        //authMerchant_objects.changeAccountID(e[1]);
        setCompanyID(e[1]);
        setCompanyName(e[2]);
        setBusinessType(e[3]);
        setCompanyAddressNumber(e[4]);
        setCompanyStreetName(e[5]);
        setCompanyCity(e[6]);
        setCompanyCityDistrict(e[7]);
        setCompanyEmail(e[8]);
        setCompanyPhoneNumber(e[9]);
        setCustomerRating(e[10]);
        setCompanyLatitude(e[11]);
        setCompanyLongitude(e[12]);

        if(e[3] == "T1")
        {
            setHotelHomepageModal(e[0]);
        }
        else if(e[3] == "T2")
        {
            setProServiceHomepageModal(e[0]);
        }
        else if(e[3] == "T3")
        {
            setRetailHomepageModal(e[0]);
        }

    }
    //alert("In List Hotel");
    //alert(authMerchant_objects.authenticated);
    //alert(authMerchant_objects.acctID);

        return (
            <React.Fragment>

               {searchResults.length == 0 && <div className='zList_companyImage_list'>

                <IonCard className='card_merchantList'>

                        <div className='zList_img'>

                            {/*<IonImg className='zList_img_inside' src={detailData.companyImage}></IonImg>*/}
                            <h2>LOADING</h2>
                        </div>

                {/*} </IonButton>*/}
                </IonCard>

                </div>}

                { searchResults.length > 0 &&  <div className='zList_companyImage_list'>

               {searchResults.map((detailData) =>   {
                                return (
                                    <IonCard className='card_merchantList'>
                                    <IonButton className='hidden_button' key={detailData.companyAcctID} fill='clear' onClick={ () => zPub_selectMerchantID([true, detailData.companyAcctID, detailData.companyName, detailData.businessType, detailData.companyAddressNumber, detailData.streetName, detailData.city, detailData.cityDistrict, detailData.companyEmail, detailData.companyPhoneNumber, detailData.customerRating, detailData.latitude, detailData.longitude]) } >
                                        <IonGrid className='gridMain_merchantList_top'>
                                            <IonRow >
                                                <IonCol className='zPub_list_gridCol_title'>{detailData.companyName}</IonCol>
                                            </IonRow>
                                            <IonRow>
                                                <IonCol>
                                                {(detailData.latitude != undefined && detailData.longitude != undefined) && <GPSC_Component data={{
                                                        companyLatitude: detailData.latitude, 
                                                        companyLongitude: detailData.longitude,
                                                        }}></GPSC_Component>}
                                                </IonCol>
                                            </IonRow>
                                        </IonGrid >
        
                                        <div className='zList_companyImage_list_div'>
        
                                                <CachedImage  
                                                imageUrl={detailData.companyImage}
                                                fileName={detailData.companyImage} 
                                                className="zList_companyImage_list_inside"
                                                alt="Example Cached Image"
                                                ></CachedImage>        
                                        </div>

                                        {/*<IonGrid className='gridMain_merchantList_bottom'>
                                            <IonRow >
                                                <IonCol className='zPub_gridCol'>{detailData.customerRating}</IonCol>
                                            </IonRow>
                                            </IonGrid>*/}

                                    </IonButton>
                                </IonCard>
                                );
                            })}
                </div>}

                
                {(hotelHompageModal == true && businessType == "T1") && <Hotels_Homepage openModal={hotelHompageModal} closeModal={() => setHotelHomepageModal(false)} data={{
                    companyId: companyID, 
                    companyName: companyName,
                    companyAddressNumber: companyAddressNumber,
                    companyStreetName: companyStreetName,
                    companyCity: companyCity,
                    companyCityDistrict: companyCityDistrict,
                    companyEmail: companyEmail,
                    companyPhoneNumber: companyPhoneNumber,
                    customerRating: customerRating,
                    }}></Hotels_Homepage>}

                    {(proServicesHomepageModal == true && businessType == "T2") &&<ProService_Homepage openModal={setProServiceHomepageModal} closeModal={() => setProServiceHomepageModal(false)} data={{
                    companyId: companyID, 
                    companyName: companyName,
                    companyAddressNumber: companyAddressNumber,
                    companyStreetName: companyStreetName,
                    companyCity: companyCity,
                    companyCityDistrict: companyCityDistrict,
                    companyEmail: companyEmail,
                    companyPhoneNumber: companyPhoneNumber,
                    customerRating: customerRating,
                    }}></ProService_Homepage>}

                {(retailHompageModal == true && businessType == "T3")  && <Retail_Homepage openModal={retailHompageModal} closeModal={() => setRetailHomepageModal(false)} data={{
                    companyId: companyID, 
                    companyName: companyName,
                    companyAddressNumber: companyAddressNumber,
                    companyStreetName: companyStreetName,
                    companyCity: companyCity,
                    companyCityDistrict: companyCityDistrict,
                    companyEmail: companyEmail,
                    companyPhoneNumber: companyPhoneNumber,
                    customerRating: customerRating,
                    }}></Retail_Homepage>}

            </React.Fragment>
        )
}